real.button = {

    loading : function(btn, parent) {
        // Put button in loading state.
        btn.prop('disabled', true).addClass('disabled loading');

        // Put first FontAwesome icon (if any found) to loading state.
        if(btn.find('.fa:visible').length > 0) {
            real.fa.loading(btn.find('.fa:visible:first'));
        } else {
            real.fa.loading(btn.find('.fa:first'));
        }

        if(!parent) {
            return;
        }

        // Disable all buttons and inputs from parent.
        real.dom.disable(parent);
    },

    reset : function(btn, parent) {
        // Reset button loading state.
        btn.prop('disabled', false).removeClass('disabled loading');

        // Reset first FontAwesome icon (if any found).
        real.fa.reset(btn.find('.fa.fa-circle-o-notch.fa-spin'));

        if(!parent) {
            return;
        }

        // Reset all buttons and inputs from parent.
        real.dom.enable(parent);
    },

    isLoading : function(btn) {
        return btn.is('.disabled.loading');
    }

};
